import { GameConstants } from "../../../GameConstants";
import { StageContainer } from "../StageContainer";
import { Car } from "../cars/Car";
import { RoadManager } from "../Roadmanager";
import { GameVars } from "../../../GameVars";
import { AudioManager } from "../../../AudioManager";


    export class Ragdoll extends Phaser.Sprite {

        public static readonly RIGHT_ARM_ANGLE_RANGE: {a1: number, a2: number} = {a1: -35, a2: 90};
        public static readonly LEFT_ARM_ANGLE_RANGE: {a1: number, a2: number} = {a1: 35, a2: -90};
        private static readonly LINE_THICKNESS = 15;

        public tweening: boolean;
        public collided: boolean;

        public bodySprite: Phaser.Sprite;

        private ragdollContainer: Phaser.Group;
        private head: Phaser.Graphics;

     
        private canRightLegTremble: boolean;
        private trembling: boolean;
        private f: number;
        private angleRightLeg: number;
        private framesDurationTween: number;
        private diameterBlood: number;

        constructor(game: Phaser.Game) {

            super(game, 0, 0, "texture_atlas_1", "hit_" + Math.floor(Math.random() * 3 + 1) + ".png");

            this.name = "ragdoll";
            this.scale.y = .85; // para dar sensacion de profundidad 
            this.anchor.set(.5);

            this.game.physics.enable(this, Phaser.Physics.ARCADE);

            let body = <Phaser.Physics.Arcade.Body> this.body;
            body.isCircle = true;
            body.radius = 5;
            body.offset.set(0, -10);

            this.canRightLegTremble = Math.random() > .7;
            this.trembling = false;
            this.f = 0;
            this.tweening = false;
            this.collided = false;
            this.framesDurationTween = 0;
            this.diameterBlood = 1;
        }

        public update(): void {

            super.update();

            if (this.y < -50 || this.y > GameConstants.GAME_HEIGHT + 50 || this.x < -50 || this.x > GameConstants.GAME_WIDTH + 50) {
                StageContainer.currentInstance.removeRagdoll(this);
                return;
            }

            if (this.tweening) {

                this.f ++;

                if (this.f > this.framesDurationTween * .5 && this.f % 2 === 0) {
                    StageContainer.currentInstance.addBloodDrop(this.x, this.y);
                }

            } else {

                if (this.canRightLegTremble) {

                    this.f++;
    
                    if (this.trembling) {
    
                        if (this.f === 300) {
                            this.trembling = false;
                            this.f = 0;
                        }
    
                    } else {
    
                        if (this.f === 300) {
                            this.trembling = true;
                            this.f = 0;
                        }
                    }
                }
            }

            if (this.collided) {

                if (this.body.velocity.y > 0) {
                    this.body.velocity.y -= 2;

                    if (this.body.velocity.y < 0) {
                        this.body.velocity.y = 0;
                    }
                } else if (this.body.velocity.y < 0) {
                    this.body.velocity.y += 2;

                    if (this.body.velocity.y > 0) {
                        this.body.velocity.y = 0;
                    }
                }

                if (this.body.velocity.y === 0) {
                    this.collided = false;
                    this.body.velocity.x = 0;
                    this.body.velocity.y = 0;
                    this.diameterBlood = 1;
                }

                if (Math.random() < .5) {
                    StageContainer.currentInstance.addBloodDrop(this.x + Math.random() * 4 - 2, this.y);
                }
                
            } else {

                if (this.diameterBlood < 8) {
                    
                    this.diameterBlood += .005;

                    if (this.diameterBlood > 2) {
                        StageContainer.currentInstance.addBloodDropStatic(this.x, this.y, this.diameterBlood);
                    }
                }
            }
        }

        public onCarCollision(car: Car): void {

            if (!this.tweening && !this.collided) {

                RoadManager.onRagdollCollision(this.x, this.y);

                this.changeForm();

                let dir = 1;
                let extra = 0;

                if (car.lane >= 3) {
                    dir = -1;
                }

                if (car.fastCar) {
                    extra = 150;
                }

                this.collided = true;
                this.body.velocity.y = Math.round(Math.random() * 150 + 150 + extra) * dir;
                this.body.velocity.x = Math.round(Math.random() * 10 - 5);

                const rand = GameVars.randomDataGenerator.integerInRange(0, 3);
                AudioManager.playSound("splat_dead_" + rand, false, .2);
            }
        }

        public hit(x: number, y: number, car: Car): void {

            this.tweening = true;
            this.f = 0;
            this.x = x;
            this.y = y;

            this.changeForm();

            let dx = GameVars.randomDataGenerator.realInRange(80, 150);
            
            if (Math.random() < .5) {
                dx *= -1;
            } 

            while (dx + this.x > 320 && dx + this.x < 490) {
                dx = GameVars.randomDataGenerator.realInRange(30, 150);
            
                if (Math.random() < .5) {
                    dx *= -1;
                } 
            } 

            let dy = GameVars.randomDataGenerator.realInRange(50, 150);

            if (car.lane >= 3) {
                dy *= -1;
            }

            if (car.fastCar) {
                dy *= 2.5;
            }

            let t = 450;

            this.framesDurationTween = Math.round(t / 1000 * 60);

            this.game.add.tween(this)
                .to({ x: this.x + dx, y: this.y + dy}, t, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function(): void {
                    this.tweening = false;
                    this.f = 0;
                    StageContainer.currentInstance.ragdollStoppedMoving(this);
                }, this);
        }

        private changeForm(): void {

            let angle = GameVars.randomDataGenerator.realInRange(Ragdoll.RIGHT_ARM_ANGLE_RANGE.a1, Ragdoll.RIGHT_ARM_ANGLE_RANGE.a2);
            let t = GameVars.randomDataGenerator.integerInRange(500, 900);

            /* this.game.add.tween(this.rightArm)
                .to({ angle: angle}, t, Phaser.Easing.Elastic.Out, true);

            angle = GameVars.randomDataGenerator.realInRange(Ragdoll.LEFT_ARM_ANGLE_RANGE.a1, Ragdoll.LEFT_ARM_ANGLE_RANGE.a2);
            t = GameVars.randomDataGenerator.integerInRange(500, 900);
            this.game.add.tween(this.leftArm)
                .to({ angle: angle}, t, Phaser.Easing.Elastic.Out, true);

            angle = GameVars.randomDataGenerator.realInRange(Ragdoll.LEFT_ARM_ANGLE_RANGE.a1, Ragdoll.LEFT_ARM_ANGLE_RANGE.a2);
            t = GameVars.randomDataGenerator.integerInRange(500, 900);
            this.game.add.tween(this.rightLeg)
                .to({ angle: angle}, t, Phaser.Easing.Elastic.Out, true)
                .onComplete.add(function(): void {
                    this.angleRightLeg = this.rightLeg.angle;
                }, this);

            angle =  GameVars.randomDataGenerator.realInRange(Ragdoll.LEFT_ARM_ANGLE_RANGE.a1, Ragdoll.LEFT_ARM_ANGLE_RANGE.a2);
            t = GameVars.randomDataGenerator.integerInRange(500, 900);
            this.game.add.tween(this.leftLeg)
                .to({ angle: angle}, t, Phaser.Easing.Elastic.Out, true); */

            angle = GameVars.randomDataGenerator.realInRange(-90, 90);
            t = GameVars.randomDataGenerator.integerInRange(500, 900);

            this.game.add.tween(this)
                .to({ angle: angle}, t, Phaser.Easing.Cubic.Out, true);
        }
    }
